__turbopack_context__.v({
  "className": "geist_2ae47f08-module__h69qWW__className",
  "variable": "geist_2ae47f08-module__h69qWW__variable",
});
